// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../../../../../core/reducers';
import { getIsLoading } from '../../../../../core/reducers/common';

@Component({
	selector: 'kt-delete-entity-dialog',
	templateUrl: './delete-entity-dialog.component.html'
})
export class DeleteEntityDialogComponent implements OnInit {
	// Public properties
	loading$: Observable<boolean>;

	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<DeleteEntityDialogComponent>
	 * @param data: any
	 */
	constructor(
		private store: Store<any>,
		public dialogRef: MatDialogRef<DeleteEntityDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { 
		this.loading$ = this.store.select((state) => state.common.isLoading);
	}

	ngOnInit() {
	}

	// Event handlers
	onNoClick(): void {
		this.dialogRef.close();
	}

	onYesClick(): void {
		this.data.onDelete();
		this.loading$.subscribe(res => {
			if (!res) {
				this.dialogRef.close(true);
			}
		});
	}
}
